module.exports = {
    AUTH: 'https://login.paytmmoney.com',
    PASSCODE_URL: 'https://passcode.paytmmoney.com/stocks/passcode',
    DATA: 'https://api-eq.paytmmoney.com',
    ORDERS: 'https://api-eq-order.paytmmoney.com',
    DATA_BROADCAST: 'wss://broadcast.paytmmoney.com',
    MDE_BROADCAST: 'wss://api-eq-pro.paytmmoney.com/broadcast-service/ws/feed',
    MDE_GATEWAY: 'https://api-eq-pro.paytmmoney.com',
    ORDER_BROADCAST: 'wss://broadcast-order.paytmmoney.com/bcorder?version=2',
    PROFILE: 'https://api.paytmmoney.com',
    PLATFORM: 'https://api-pf.paytmmoney.com',
    WEB_APP: 'https://paytmmoney.com',
    STOREFRONT: 'https://api.paytmmoney.com/aggr/sf/prod-pml-web-equity-dashboard',
    PROMO_ID: 331195,
    EQUITY_DOWNTIME: 'https://static.paytmmoney.com/data/v1/production/frontend-config.json',
    MDE_CONFIG: 'https://static.paytmmoney.com/data/v1/production/mde-config.json',
    BASE: 'https://api.paytmmoney.com',
    ALLOWED_USER_JSON: 'https://static.paytmmoney.com/data/v1/production/tvcohort.json',
    ORDER_RESTRICTION_CONFIG: 'https://static.paytmmoney.com/data/v1/production/orderrestrictions.json',
    EQ_MISC_CONFIG: 'https://static.paytmmoney.com/data/v1/eq-web-misc-config.json',
    FNO_SEARCH: 'https://static.paytmmoney.com/data/v1/production/fno-dashboard-search-scrips.json',
    EQUITY_INFOCARD: 'https://static.paytmmoney.com/data/v1/production/equity-infocard.json',
    LOGGER: 'https://logger.paytmmoney.com',
};
